/** Upgrade http:// to https:// for non-local builds to prevent mixed-content blocking. */
const enforceHttps = (url: string | undefined): string => {
	if (!url) return "";
	const env = import.meta.env["VITE_BUILD_ENV"];
	if (env === "local") return url;
	return url.replace(/^http:\/\//i, "https://");
};

// Azure DevOps passes an unset pipeline variable through as the literal $(NAME); treat that as unset.
const resolveBuildVar = (value: string | undefined): string => (!value || value.startsWith("$(") ? "" : value);

const Config: AppConfig = {
	adminGraphqlEndpoint: enforceHttps(import.meta.env["VITE_ADMIN_GRAPHQL_ENDPOINT"]),
	agGridLicenseKey: import.meta.env["VITE_AGGRID_LICENSE_KEY"] || "",
	aiOrchestratorUrl: resolveBuildVar(import.meta.env["VITE_AI_ORCHESTRATOR_URL"]),
	authUrl: enforceHttps(import.meta.env["VITE_AUTH_URL"]),
	branch: import.meta.env["VITE_BUILD_BRANCH"]!,
	buildVersion: import.meta.env["VITE_BUILD_VERSION"]!,
	clientId: import.meta.env["VITE_CLIENT_ID"]!,
	decimalPrecision: 5,
	endpoint: enforceHttps(import.meta.env["VITE_GRAPHQL_ENDPOINT"]),
	environment: import.meta.env["VITE_BUILD_ENV"]!,
	idbVersion: 1,
	intelligenceEndpoint: enforceHttps(import.meta.env["VITE_INTELLIGENCE_ENDPOINT"]),
	navDrawerCoverWidth: 900,
	releaseVersion: import.meta.env["VITE_RELEASE_VERSION"]!,
	salesContactUrl: import.meta.env["VITE_SALES_CONTACT_URL"] || "mailto:hello@silverfern.com",
	sentryDSN: "https://f0e330e1b8b789aa25bf7b8cd633f4b1@o1137736.ingest.us.sentry.io/4509208702353408",
	sfApiUrl: enforceHttps(import.meta.env["VITE_SF_API_URL"]),
	tenantId: import.meta.env["VITE_TENANT_ID"]!,
	tokenDuration: parseInt(import.meta.env["VITE_TOKEN_DURATION_SECONDS"]!) || 3600,
	webPushPublicKey: resolveBuildVar(import.meta.env["VITE_WEB_PUSH_PUBLIC_KEY"])
};

export default Config;
